export default __webpack_public_path__ + "2c8bc855d5d3df4ad65e49b811d5b148.png";